import { onAuthStateChanged, signInWithCustomToken, signOut } from "firebase/auth";
import { auth } from "../services/Firestore";
import { TWS } from "../services/WebServices";

// Firebase users of clients are 'c_<clientId>' (see /app-firebase-token).
// The phone (OTP) check at login signs in a different user, which is replaced here.
const isClientUser = user => !!user && user.uid.startsWith("c_");

// currentUser is null until the saved session is restored (no authStateReady() in firebase 9)
const authRestored = () =>
  new Promise(resolve => {
    const unsubscribe = onAuthStateChanged(auth, () => {
      unsubscribe();
      resolve();
    });
  });

/**
 * Signs the logged-in client into Firebase Auth so Firestore requests carry
 * their identity. Reuses the session the SDK keeps in the browser; only asks
 * the server for a custom token when there is none.
 */
export async function ensureFirebaseUser() {
  await authRestored();
  if (isClientUser(auth.currentUser)) {
    return auth.currentUser;
  }
  const { firebase_token } = await TWS.getFirebaseToken();
  const credential = await signInWithCustomToken(auth, firebase_token);
  return credential.user;
}

export function firebaseSignOut() {
  return signOut(auth).catch(() => {});
}
